import createVueComponent from '../createVueComponent';

const GitPullRequestClosed = createVueComponent('GitPullRequestClosedIcon', [
  ['circle', { cx: '18', cy: '18', r: '3', key: '1xkwt0' }],
  ['circle', { cx: '6', cy: '6', r: '3', key: '1lh9wr' }],
  ['path', { d: 'M18 11.5V15', key: '65xf6f' }],
  ['path', { d: 'm21 3-6 6', key: '16nqsk' }],
  ['path', { d: 'm21 9-6-6', key: '9j17rh' }],
  ['line', { x1: '6', x2: '6', y1: '9', y2: '21', key: 'rroup' }],
]);

export default GitPullRequestClosed;
